import { useEffect } from 'react';

import { useTradingSessionStore } from '@/features/tradingSession/store';

import { useMigrationStore } from './store';

/**
 * The reopen half of the migration's wallet gate, the same falling edge as
 * `useCustodialWalletRequirement`: the dialog's Connect wallet button closes
 * it and opens the Connected Wallet window; when that window closes with a
 * wallet (eip712) authority, the dialog opens again. A cancelled window leaves
 * it closed; nothing loops.
 */
export function useMigrationWalletRequirement(): void {
    const reopenPending = useMigrationStore(
        (s) => s.reopenAfterWalletAuthority,
    );
    const reauthenticationOpen = useTradingSessionStore(
        (s) => s.reauthenticationOpen,
    );
    const status = useTradingSessionStore((s) => s.status);
    const clockNowMs = useTradingSessionStore((s) => s.clockNowMs);

    const hasWalletAuthority =
        status?.state === 'active' &&
        status.method === 'eip712' &&
        useTradingSessionStore.getState().hasActiveAuthority(clockNowMs);

    // applyStatus runs before the window closes, so a granted wallet
    // authority is already visible on the falling edge.
    useEffect(() => {
        if (!reopenPending || reauthenticationOpen) return;
        const migration = useMigrationStore.getState();
        migration.clearReopenAfterWalletAuthority();
        if (!hasWalletAuthority || migration.isOpen) return;
        migration.open();
    }, [hasWalletAuthority, reauthenticationOpen, reopenPending]);
}
